import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    loai: null, // string, optional  //Loại nhóm phản hồi, nhận một trong hai giá trị sau: kdl, hdv
    doi_tuong_nhan: [], // array of string, optional // Các đối tượng có thể nhận phản hồi từ nhóm này
    ten: { //object, optional // Tên nhóm
        vi: null, // string, optional  // Tên tiếng Việt
        en: null, // string, optional  // Tên tiếng Anh
    },
    thu_tu: null, //integer, optional // Thứ tự sắp xếp
    chuyen_tcqltt: null, //boolean, optional // Cho biết các phản hồi vào nhóm này có chuyển sang tổng cục quản lý thị trường hay không
};

// validation form
model.validForm = {

    loai: [ValidService.required], //Loại nhóm phản hồi, nhận một trong hai giá trị sau: kdl, hdv
    doi_tuong_nhan: [],
    ten: { //object, optional // Các thể loại ảnh của tin tức
        vi: [ValidService.required], // string, optional  // Tên tiếng Việt
        en: [ValidService.required], // string, optional  // Tên tiếng Anh
    },
    thu_tu: [], //integer, optional // Thứ tự sắp xếp
    chuyen_tcqltt: [], //boolean, optional // Cho biết các phản hồi vào nhóm này có chuyển sang tổng cục quản lý thị trường hay không
};

// dữ liệu mẫu các form khác
model.dataFormOther = {};

// validation các form khác
model.validFormOther = {};

model.loaiNhomPhanHoi = [
    // {
    //     code: "kdl",
    //     text: "Khách du lịch"
    // },
    {
        code: "hdv",
        text: "Hướng dẫn viên"
    },
    {
        code: "ddat",
        text: "Điểm đến"
    },
    {
        code: "trang_vang",
        text: "Trang vàng"
    },
];

model.trangThaiChuyen = [{
        code: "true",
        text: "Chuyển sang TCQLTT"
    },
    {
        code: "false",
        text: "Không chuyển sang TCQLTT"
    }
];

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["loai", "ascending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            loai: "",
            "ten.vi": "",
            "ten.en": "",
            chuyen_tcqltt: ""
        },
        valid: {
            loai: [],
            noi_dung: [],
            chuyen_tcqltt: []
        },
        operator: {
            loai: ":regex_i:", //:regex:, $vn_text=Viêt nam
            "ten.vi": ":regex_i:",
            "ten.en": ":regex_i:"
        }
    }
};


export default model;
